const VideoRetryBox = ({ count }: { count: number }) => (
  <div className="flex flex-col items-center justify-center h-full">
    <div className="bg-surface-1 border border-white/[0.08] max-w-xs px-8 pt-8 pb-6 rounded-2xl text-center">
      <div className="relative w-12 h-12 mx-auto mb-4">
        <div className="absolute inset-0 rounded-full border-2 border-white/[0.06]" />
        <div className="absolute inset-0 rounded-full border-2 border-transparent border-t-myAmber animate-spin" style={{ animationDuration: "1.5s" }} />
      </div>
      <p className="text-base text-white font-semibold mb-1">
        Video yüklenemedi
      </p>
      <p className="text-sm text-white/40">Yeniden deneniyor... ({count})</p>
    </div>
  </div>
);

export default VideoRetryBox;
